import React from "react"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./Supervision.css"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { useMaxWidthContext } from "../../../hooks/useMaxWidth"

const Supervision = ({
    roomNumber,
    dateStatusChanged,
    roomTypeName,
    supervisionColaboradorName,
    supervisionTimeLimit,
    hasIncidences,
}: RoomStatusProps) => {
    const [elapsedTime] = useElapsedTime(supervisionTimeLimit || new Date())

    const [now] = useTimePulse()
    const { maxWidth } = useMaxWidthContext()

    const itemHeight = "20cqh"

    return (
        <Wrapper
            hasIncidences={hasIncidences}
            bgColor="var(--card-supervision)"
            alertBgColor1={now > (supervisionTimeLimit || now) ? "var(--white)" : null}
            alertBgColor2={now > (supervisionTimeLimit || now) ? "var(--card-supervision)" : null}
        >
            <RoomCardHeader
                iconName="Search"
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                iconBgColor="var(--supervision)"
                roomTypeAbbreviation={roomTypeName?.[0]}
            />
            <RoomCardBody>
                <div className="room-card--xs--supervision__description_wrapper" style={{ maxWidth }}>
                    {now > (supervisionTimeLimit || now) ? (
                        <span className="room-card--xs--supervision__timer--timeout" style={{ fontSize: itemHeight }}>
                            +{elapsedTime}
                        </span>
                    ) : (
                        <span className="room-card--xs--supervision__timer" style={{ fontSize: itemHeight }}>
                            {elapsedTime}
                        </span>
                    )}
                    <span className="room-card--xs--supervision__description" style={{ fontSize: itemHeight }}>
                        {supervisionColaboradorName}
                    </span>
                </div>
            </RoomCardBody>
        </Wrapper>
    )
}

export default Supervision
